/**
 * FlowState Desktop OS — full-screen interactive desktop environment.
 *
 * Accessible at /os. Uses its own auth guard (not under _admin) because
 * the desktop is a full-screen experience that does not use AdminShellLayout.
 *
 * The OS module lives in src/os/ and was built as a standalone
 * macOS/Ubuntu-style desktop with a window manager, app dock, 54 apps,
 * a virtual file system, and a boot sequence.
 */

import { createFileRoute, redirect } from '@tanstack/react-router';
import type { RouterContext } from '../../router';
import { isDesktopOsEnabled } from '../../lib/feature-flags';
import OsShell from '../../os/OsShell';

export const Route = createFileRoute('/os/')({
  beforeLoad: async ({ context }) => {
    if (!isDesktopOsEnabled()) {
      throw redirect({ to: '/' });
    }
    if (typeof window === 'undefined') return;
    const sb = (context as RouterContext).supabase;
    if (!sb) return;
    const { data: { session } } = await sb.auth.getSession();
    if (!session) {
      throw redirect({ to: '/auth' });
    }
  },
  component: OsPage,
});

function OsPage() {
  return (
    <div className="fixed inset-0 overflow-hidden bg-black">
      <OsShell />
    </div>
  );
}
